'use client';

import { PropsWithChildren } from 'react';
import TopBar from 'src/components/TopBar/TopBar';
import CentreFillScroller from 'src/components/Utils/CentreFillScroller';
import Footer from './Footer';
import { useWindowSizeIsGreaterThan } from 'src/hooks/useWindowSize';
import StatusBars from 'src/components/StatusBars/StatusBars';

const NavFooterLayout = (
	props: PropsWithChildren<{
		overflowAuto?: boolean;
		pageBackground?: string;
		/**
		 * True by default
		 */
		hideScroll?: boolean;
		middleClassName?: string;
		middleFillSpace?: boolean;
		useCustomMiddleWrapper?: boolean;
	}>
) => {
	const isTabletOrLargerScreenSize = useWindowSizeIsGreaterThan('xs');

	return (
		<div
			className="h-screen w-screen"
			style={{
				background: props.pageBackground,
			}}
		>
			<CentreFillScroller
				overflowAuto={props.overflowAuto}
				hideScroll={props.hideScroll === false ? false : true}
				fillSpace={props.middleFillSpace}
				innerClassName={props.middleClassName}
				useCustomMiddleWrapper={props.useCustomMiddleWrapper}
				top={
					<>
						<StatusBars />
						<TopBar />
					</>
				}
				middle={props.children}
				bottom={isTabletOrLargerScreenSize && <Footer />}
			/>
		</div>
	);
};

export default NavFooterLayout;
